import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <FaqSection />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <AppSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}